import { containerStyle } from '../../styles';

export default {
  container: {
    ...containerStyle
  },
  codeSentLabel: {
    textAlign: 'center',
    paddingBottom: 10,
    maxWidth: 400,
    lineHeight: 1.5
  },
  submit: {
    textTransform: 'uppercase',
    marginTop: 20
  },
  resendMail: {
    marginTop: 20,
    textDecoration: 'none'
  }
};
